import type { CountrySelectOption } from '@/components/CountrySelect/CountrySelect';

type SelfOnboardingCountry = {
  value: string;
  /** English name used when the locale cannot name this code. */
  fallback: string;
};

/** Static catalog matching backend `isPlatformCountryCode` (no public countries GET in v1). */
const SELF_ONBOARDING_COUNTRIES: SelfOnboardingCountry[] = [
  { value: 'AF', fallback: 'Afghanistan' },
  { value: 'AL', fallback: 'Albania' },
  { value: 'DZ', fallback: 'Algeria' },
  { value: 'AS', fallback: 'American Samoa' },
  { value: 'AD', fallback: 'Andorra' },
  { value: 'AO', fallback: 'Angola' },
  { value: 'AI', fallback: 'Anguilla' },
  { value: 'AQ', fallback: 'Antarctica' },
  { value: 'AG', fallback: 'Antigua and Barbuda' },
  { value: 'AR', fallback: 'Argentina' },
  { value: 'AM', fallback: 'Armenia' },
  { value: 'AW', fallback: 'Aruba' },
  { value: 'AU', fallback: 'Australia' },
  { value: 'AT', fallback: 'Austria' },
  { value: 'AZ', fallback: 'Azerbaijan' },
  { value: 'BS', fallback: 'Bahamas' },
  { value: 'BH', fallback: 'Bahrain' },
  { value: 'BD', fallback: 'Bangladesh' },
  { value: 'BB', fallback: 'Barbados' },
  { value: 'BY', fallback: 'Belarus' },
  { value: 'BE', fallback: 'Belgium' },
  { value: 'BZ', fallback: 'Belize' },
  { value: 'BJ', fallback: 'Benin' },
  { value: 'BM', fallback: 'Bermuda' },
  { value: 'BT', fallback: 'Bhutan' },
  { value: 'BO', fallback: 'Bolivia' },
  { value: 'BA', fallback: 'Bosnia and Herzegovina' },
  { value: 'BW', fallback: 'Botswana' },
  { value: 'BR', fallback: 'Brazil' },
  { value: 'IO', fallback: 'British Indian Ocean Territory' },
  { value: 'VG', fallback: 'British Virgin Islands' },
  { value: 'BN', fallback: 'Brunei' },
  { value: 'BG', fallback: 'Bulgaria' },
  { value: 'BF', fallback: 'Burkina Faso' },
  { value: 'BI', fallback: 'Burundi' },
  { value: 'KH', fallback: 'Cambodia' },
  { value: 'CM', fallback: 'Cameroon' },
  { value: 'CA', fallback: 'Canada' },
  { value: 'CV', fallback: 'Cape Verde' },
  { value: 'KY', fallback: 'Cayman Islands' },
  { value: 'CF', fallback: 'Central African Republic' },
  { value: 'TD', fallback: 'Chad' },
  { value: 'CL', fallback: 'Chile' },
  { value: 'CN', fallback: 'China' },
  { value: 'CX', fallback: 'Christmas Island' },
  { value: 'CC', fallback: 'Cocos Islands' },
  { value: 'CO', fallback: 'Colombia' },
  { value: 'KM', fallback: 'Comoros' },
  { value: 'CK', fallback: 'Cook Islands' },
  { value: 'CR', fallback: 'Costa Rica' },
  { value: 'HR', fallback: 'Croatia' },
  { value: 'CU', fallback: 'Cuba' },
  { value: 'CW', fallback: 'Curacao' },
  { value: 'CY', fallback: 'Cyprus' },
  { value: 'CZ', fallback: 'Czech Republic' },
  { value: 'CD', fallback: 'Democratic Republic of the Congo' },
  { value: 'DK', fallback: 'Denmark' },
  { value: 'DJ', fallback: 'Djibouti' },
  { value: 'DM', fallback: 'Dominica' },
  { value: 'DO', fallback: 'Dominican Republic' },
  { value: 'TL', fallback: 'East Timor' },
  { value: 'EC', fallback: 'Ecuador' },
  { value: 'EG', fallback: 'Egypt' },
  { value: 'SV', fallback: 'El Salvador' },
  { value: 'GQ', fallback: 'Equatorial Guinea' },
  { value: 'ER', fallback: 'Eritrea' },
  { value: 'EE', fallback: 'Estonia' },
  { value: 'ET', fallback: 'Ethiopia' },
  { value: 'FK', fallback: 'Falkland Islands' },
  { value: 'FO', fallback: 'Faroe Islands' },
  { value: 'FJ', fallback: 'Fiji' },
  { value: 'FI', fallback: 'Finland' },
  { value: 'FR', fallback: 'France' },
  { value: 'PF', fallback: 'French Polynesia' },
  { value: 'GA', fallback: 'Gabon' },
  { value: 'GM', fallback: 'Gambia' },
  { value: 'GE', fallback: 'Georgia' },
  { value: 'DE', fallback: 'Germany' },
  { value: 'GH', fallback: 'Ghana' },
  { value: 'GI', fallback: 'Gibraltar' },
  { value: 'GR', fallback: 'Greece' },
  { value: 'GL', fallback: 'Greenland' },
  { value: 'GD', fallback: 'Grenada' },
  { value: 'GU', fallback: 'Guam' },
  { value: 'GT', fallback: 'Guatemala' },
  { value: 'GG', fallback: 'Guernsey' },
  { value: 'GN', fallback: 'Guinea' },
  { value: 'GW', fallback: 'Guinea-Bissau' },
  { value: 'GY', fallback: 'Guyana' },
  { value: 'HT', fallback: 'Haiti' },
  { value: 'HN', fallback: 'Honduras' },
  { value: 'HK', fallback: 'Hong Kong' },
  { value: 'HU', fallback: 'Hungary' },
  { value: 'IS', fallback: 'Iceland' },
  { value: 'IN', fallback: 'India' },
  { value: 'ID', fallback: 'Indonesia' },
  { value: 'IR', fallback: 'Iran' },
  { value: 'IQ', fallback: 'Iraq' },
  { value: 'IE', fallback: 'Ireland' },
  { value: 'IM', fallback: 'Isle of Man' },
  { value: 'IL', fallback: 'Israel' },
  { value: 'IT', fallback: 'Italy' },
  { value: 'CI', fallback: 'Ivory Coast' },
  { value: 'JM', fallback: 'Jamaica' },
  { value: 'JP', fallback: 'Japan' },
  { value: 'JE', fallback: 'Jersey' },
  { value: 'JO', fallback: 'Jordan' },
  { value: 'KZ', fallback: 'Kazakhstan' },
  { value: 'KE', fallback: 'Kenya' },
  { value: 'KI', fallback: 'Kiribati' },
  { value: 'XK', fallback: 'Kosovo' },
  { value: 'KW', fallback: 'Kuwait' },
  { value: 'KG', fallback: 'Kyrgyzstan' },
  { value: 'LA', fallback: 'Laos' },
  { value: 'LV', fallback: 'Latvia' },
  { value: 'LB', fallback: 'Lebanon' },
  { value: 'LS', fallback: 'Lesotho' },
  { value: 'LR', fallback: 'Liberia' },
  { value: 'LY', fallback: 'Libya' },
  { value: 'LI', fallback: 'Liechtenstein' },
  { value: 'LT', fallback: 'Lithuania' },
  { value: 'LU', fallback: 'Luxembourg' },
  { value: 'MO', fallback: 'Macau' },
  { value: 'MK', fallback: 'Macedonia' },
  { value: 'MG', fallback: 'Madagascar' },
  { value: 'MW', fallback: 'Malawi' },
  { value: 'MY', fallback: 'Malaysia' },
  { value: 'MV', fallback: 'Maldives' },
  { value: 'ML', fallback: 'Mali' },
  { value: 'MT', fallback: 'Malta' },
  { value: 'MH', fallback: 'Marshall Islands' },
  { value: 'MR', fallback: 'Mauritania' },
  { value: 'MU', fallback: 'Mauritius' },
  { value: 'YT', fallback: 'Mayotte' },
  { value: 'MX', fallback: 'Mexico' },
  { value: 'FM', fallback: 'Micronesia' },
  { value: 'MD', fallback: 'Moldova' },
  { value: 'MC', fallback: 'Monaco' },
  { value: 'MN', fallback: 'Mongolia' },
  { value: 'ME', fallback: 'Montenegro' },
  { value: 'MS', fallback: 'Montserrat' },
  { value: 'MA', fallback: 'Morocco' },
  { value: 'MZ', fallback: 'Mozambique' },
  { value: 'MM', fallback: 'Myanmar' },
  { value: 'NA', fallback: 'Namibia' },
  { value: 'NR', fallback: 'Nauru' },
  { value: 'NP', fallback: 'Nepal' },
  { value: 'NL', fallback: 'Netherlands' },
  { value: 'AN', fallback: 'Netherlands Antilles' },
  { value: 'NC', fallback: 'New Caledonia' },
  { value: 'NZ', fallback: 'New Zealand' },
  { value: 'NI', fallback: 'Nicaragua' },
  { value: 'NE', fallback: 'Niger' },
  { value: 'NG', fallback: 'Nigeria' },
  { value: 'NU', fallback: 'Niue' },
  { value: 'KP', fallback: 'North Korea' },
  { value: 'MP', fallback: 'Northern Mariana Islands' },
  { value: 'NO', fallback: 'Norway' },
  { value: 'OM', fallback: 'Oman' },
  { value: 'PK', fallback: 'Pakistan' },
  { value: 'PW', fallback: 'Palau' },
  { value: 'PS', fallback: 'Palestine' },
  { value: 'PA', fallback: 'Panama' },
  { value: 'PG', fallback: 'Papua New Guinea' },
  { value: 'PY', fallback: 'Paraguay' },
  { value: 'PE', fallback: 'Peru' },
  { value: 'PH', fallback: 'Philippines' },
  { value: 'PN', fallback: 'Pitcairn' },
  { value: 'PL', fallback: 'Poland' },
  { value: 'PT', fallback: 'Portugal' },
  { value: 'PR', fallback: 'Puerto Rico' },
  { value: 'QA', fallback: 'Qatar' },
  { value: 'CG', fallback: 'Republic of the Congo' },
  { value: 'RE', fallback: 'Reunion' },
  { value: 'RO', fallback: 'Romania' },
  { value: 'RU', fallback: 'Russia' },
  { value: 'RW', fallback: 'Rwanda' },
  { value: 'BL', fallback: 'Saint Barthelemy' },
  { value: 'SH', fallback: 'Saint Helena' },
  { value: 'KN', fallback: 'Saint Kitts and Nevis' },
  { value: 'LC', fallback: 'Saint Lucia' },
  { value: 'MF', fallback: 'Saint Martin' },
  { value: 'PM', fallback: 'Saint Pierre and Miquelon' },
  { value: 'VC', fallback: 'Saint Vincent and the Grenadines' },
  { value: 'WS', fallback: 'Samoa' },
  { value: 'SM', fallback: 'San Marino' },
  { value: 'ST', fallback: 'Sao Tome and Principe' },
  { value: 'SA', fallback: 'Saudi Arabia' },
  { value: 'SN', fallback: 'Senegal' },
  { value: 'RS', fallback: 'Serbia' },
  { value: 'SC', fallback: 'Seychelles' },
  { value: 'SL', fallback: 'Sierra Leone' },
  { value: 'SG', fallback: 'Singapore' },
  { value: 'SX', fallback: 'Sint Maarten' },
  { value: 'SK', fallback: 'Slovakia' },
  { value: 'SI', fallback: 'Slovenia' },
  { value: 'SB', fallback: 'Solomon Islands' },
  { value: 'SO', fallback: 'Somalia' },
  { value: 'ZA', fallback: 'South Africa' },
  { value: 'KR', fallback: 'South Korea' },
  { value: 'SS', fallback: 'South Sudan' },
  { value: 'ES', fallback: 'Spain' },
  { value: 'LK', fallback: 'Sri Lanka' },
  { value: 'SD', fallback: 'Sudan' },
  { value: 'SR', fallback: 'Suriname' },
  { value: 'SJ', fallback: 'Svalbard and Jan Mayen' },
  { value: 'SZ', fallback: 'Swaziland' },
  { value: 'SE', fallback: 'Sweden' },
  { value: 'CH', fallback: 'Switzerland' },
  { value: 'SY', fallback: 'Syria' },
  { value: 'TW', fallback: 'Taiwan' },
  { value: 'TJ', fallback: 'Tajikistan' },
  { value: 'TZ', fallback: 'Tanzania' },
  { value: 'TH', fallback: 'Thailand' },
  { value: 'TG', fallback: 'Togo' },
  { value: 'TK', fallback: 'Tokelau' },
  { value: 'TO', fallback: 'Tonga' },
  { value: 'TT', fallback: 'Trinidad and Tobago' },
  { value: 'TN', fallback: 'Tunisia' },
  { value: 'TR', fallback: 'Turkey' },
  { value: 'TM', fallback: 'Turkmenistan' },
  { value: 'TC', fallback: 'Turks and Caicos Islands' },
  { value: 'TV', fallback: 'Tuvalu' },
  { value: 'VI', fallback: 'U.S. Virgin Islands' },
  { value: 'UG', fallback: 'Uganda' },
  { value: 'UA', fallback: 'Ukraine' },
  { value: 'AE', fallback: 'United Arab Emirates' },
  { value: 'GB', fallback: 'United Kingdom' },
  { value: 'US', fallback: 'United States' },
  { value: 'UY', fallback: 'Uruguay' },
  { value: 'UZ', fallback: 'Uzbekistan' },
  { value: 'VU', fallback: 'Vanuatu' },
  { value: 'VA', fallback: 'Vatican' },
  { value: 'VE', fallback: 'Venezuela' },
  { value: 'VN', fallback: 'Vietnam' },
  { value: 'WF', fallback: 'Wallis and Futuna' },
  { value: 'EH', fallback: 'Western Sahara' },
  { value: 'YE', fallback: 'Yemen' },
  { value: 'ZM', fallback: 'Zambia' },
  { value: 'ZW', fallback: 'Zimbabwe' },
];

/**
 * Codes whose CLDR name is not the country this catalog stores.
 * `AN` is the dissolved Netherlands Antilles; CLDR now returns Curaçao.
 */
const REGION_NAME_OVERRIDES: Record<string, { en: string; es: string }> = {
  AN: { en: 'Netherlands Antilles', es: 'Antillas Neerlandesas' },
};

/**
 * Country options labeled in the active locale. The code sent to the API stays the ISO value.
 *
 * @param language BCP 47 language, such as the campaign signup language
 */
export function buildSelfOnboardingCountryOptions(language: string): CountrySelectOption[] {
  const locale = language.trim() || 'en';
  const overrideLanguage = locale.toLowerCase().startsWith('es') ? 'es' : 'en';
  let regionNames: Intl.DisplayNames | null = null;
  try {
    regionNames = new Intl.DisplayNames([locale], { type: 'region' });
  } catch {
    regionNames = null;
  }

  const options = SELF_ONBOARDING_COUNTRIES.map(({ value, fallback }) => {
    const override = REGION_NAME_OVERRIDES[value]?.[overrideLanguage];
    let name = override ?? fallback;
    if (!override && regionNames) {
      try {
        const localized = regionNames.of(value);
        if (localized && localized.toUpperCase() !== value) {
          name = localized;
        }
      } catch {
        name = fallback;
      }
    }
    return { value, label: `${name} (${value})` };
  });

  options.sort((a, b) => a.label.localeCompare(b.label, locale, { sensitivity: 'base' }));
  return options;
}
